import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import * as actions from "../../Actions/transactions";
import TransactionCodeForm from './TransactionCodeForm';
import classes from './Transactions.css';
import Tooltip from '@material-ui/core/Tooltip';
import Popover from '@material-ui/core/Popover';
import { withStyles } from '@material-ui/core/styles';
import { Menu, MenuItem } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import WhatshotRoundedIcon from '@material-ui/icons/WhatshotRounded';
import FilterListIcon from '@material-ui/icons/FilterList';
import CopyrightIcon from '@material-ui/icons/Copyright';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import CircularProgress from '@material-ui/core/CircularProgress';
import Badge from '@material-ui/core/Badge';
import { filterByOptions } from '../Common/SelectLists';
import { isMatchable as checkIsMatchable, isUnappliedRule } from './Columns/columnsHelpers';

class TransactionListMenu extends Component {

  state = {
    filterOpen: null,
    alertOpen: null,
    alertMessage: '',
  };

  handleSelectedMatch = event => {
    const { deselectTransactions, selectedTransactions } = this.props;
    const alertMessage = 'Batch Coding cannot be used when selected transactions have the same match condition.';
    const isDuplicateMatch = this.checkDuplicateMatch(selectedTransactions);

    if (isDuplicateMatch) return this.alertOpen(event, alertMessage);
    selectedTransactions.map(row => {
      const firstSuggestedMatch = { isMatch: true, value: row.SuggestedMatches[0] };
      this.props.handleSelectAccount(firstSuggestedMatch, row, true);
    })
    deselectTransactions();
  }

  handleSelectedRule = () => {
    const { deselectTransactions, selectedTransactions } = this.props;
    selectedTransactions.map(row => this.props.handleAcceptRule(row));
    deselectTransactions();
  }

  checkDuplicateMatch = (arr) => {
    const temp = [];
    for (let i = 0; i < arr.length; i++) {
      let match = arr[i].SuggestedMatches[0];
      if (temp.includes(match)) return true;
      temp.push(match);
    }
    return false;
  }

  handleCoding = value => {
    this.toggleCodeOpen();

    const { bankAccounts, account, bookId, dateRange, timeStamp, hasGST, deselectTransactions, selectedTransactions, transactionCodes: { taxCodes }, matches, isRah } = this.props;
    const isEmpty = Object.keys(value).length === 0 || Object.values(value).every(field => field === null);

    if (!isEmpty) {
      let codingInfo = value;
      // let codingInfo = { AccountCode: {}, GstCode: {}, contactId: {}, classificationId: {} };
      // Object.assign(codingInfo, value);
      const lastTransaction = selectedTransactions.length - 1;
      selectedTransactions.map((row, index) => {
        const transaction = { ...selectedTransactions.find(item => item.BankDataGUID === row.BankDataGUID) };
        const isAccountCode = codingInfo.AccountCode && Object.entries(codingInfo.AccountCode).length > 0;
        const isGstCode = codingInfo.GstCode && Object.entries(codingInfo.GstCode).length > 0;


        for (let [field, value] of Object.entries(codingInfo)) {
          if (value) transaction[field] = value.value;
        }
        transaction.bankId = account.bankId;

        if (isAccountCode) {
          const accountCodeValue = codingInfo.AccountCode;

          // Check is select account type is a bank account (transfer) or a charted account
          if (accountCodeValue.accountType !== 9) {
            transaction.accountCodeId = accountCodeValue.accountId || '';
          } else {
            // Account is a bank account 
            transaction.accountCodeId = bankAccounts.find(item => item.accountId === accountCodeValue.accountId).bankId;
          }

          transaction.accountType = accountCodeValue.accountType || ''; // set accountType or empty string if deleting transtaction coding
          if (!isGstCode) {
            // Book is registered for GST and the account code has a default GST code then add GST to transaction
            if (hasGST) {
              const taxCode = (accountCodeValue.defaultTaxCode) ? taxCodes.find(code => code.value === accountCodeValue.defaultTaxCode) : undefined;
              transaction.GstCode = accountCodeValue.defaultTaxCode || '';
              transaction.gstCodeId = (taxCode) ? taxCode.taxAccountId : ''
              transaction.gstAmount = (taxCode)
                ? transaction.Amount - transaction.Amount / (1 + taxCode.rate / 100)
                : 0;
            } else {
              transaction.GstCode = undefined;
              transaction.gstAmount = undefined
            }
          }
        }
        if (isGstCode) {
          const gstCodeValue = codingInfo.GstCode;

          transaction.gstCodeId = gstCodeValue.taxAccountId;
          transaction.gstAmount = (gstCodeValue.taxAccountId)
            ? transaction.Amount - transaction.Amount / (1 + (taxCodes.find(code => code.value === gstCodeValue.value).rate / 100))
            : 0;
        }

        // Check if transacton is already coded if it is set R1 accountCodeId and gstCodeId
        if (transaction.Coding[0]) {
          if (!transaction.accountCodeId) transaction.accountCodeId = transaction.Coding[0].R1AccountId;
          if (!transaction.gstCodeId) transaction.gstCodeId = transaction.Coding[0].R1TaxGroupId;
        }

        // Create coded object for transaction
        const coding = { Percentage: 100, Amount: transaction.Amount, CodingType: 'QuickCoding' };
        coding.AccountDate = moment.utc(transaction.TransactionDate, 'D MMM YY').unix();
        coding.AccountCode = transaction.AccountCode;
        coding.AccountType = transaction.accountType;
        coding.accountCodeId = transaction.accountCodeId;

        if (transaction.Quantity) coding.Quantity = transaction.Quantity;
        if (transaction.GstCode && transaction.GstCode !== "0") {
          coding.GstCode = transaction.GstCode;
          coding.gstCodeId = transaction.gstCodeId || taxCodes.find(code => code.value === coding.GstCode).taxAccountId;
          coding.gstAmount = transaction.gstAmount;
        }

        const codingDetails = {
          BookId: bookId,
          bankId: transaction.bankId,
          BankDataGuid: transaction.BankDataGUID,
          Coding: transaction.AccountCode ? [coding] : [],
          clientAccountId: account.value,
          description: transaction.Description,
          accountCodeId: transaction.accountCodeId || ''
        };

        transaction.Coding = (transaction.AccountCode) ? [coding] : [];
        // If no coding and transaction was coded then clear any coding details
        if (transaction.Coding.length === 0 && transaction.lockedDetails) {
          transaction.Quantity = '';
          transaction.classificationId = undefined;
          transaction.contactId = undefined;
        }
        if (transaction.contactId) codingDetails.contactId = transaction.contactId;
        if (transaction.classificationId) {
          codingDetails.classificationId = transaction.classificationId;
        } else if (this.props.classification.length) {
          const defaultCallId = this.props.classification.find(item => item.isDefault);
          codingDetails.classificationId = defaultCallId ? defaultCallId.value : undefined;
        }

        this.props.updateTransactionsList(transaction);
        this.props.codeTransaction(codingDetails, dateRange, timeStamp, false, account, index !== lastTransaction);
      });
      deselectTransactions();
    }
  }

  onFilterchanged = filter => {
    localStorage.setItem('filterBy', filter);
    this.props.updateFilterBy(filter);
    this.props.deselectTransactions();
    this.selectClose();
  }

  selectClose = () => {
    this.setState({ filterOpen: null });
  };

  handleFilterOpen = event => {
    this.setState({ filterOpen: event.currentTarget });
  };

  toggleCodeOpen = event => {
    const alertMessage = 'Batch Coding cannot be used when both Money In and Money Out transactions have been selected.';
    const { selectedTransactions } = this.props;
    for (let i = 0; i < selectedTransactions.length - 1; i++) {
      let isMixed = selectedTransactions[i].Amount < 0 ? selectedTransactions[i + 1].Amount >= 0 : selectedTransactions[i + 1].Amount < 0;
      if (isMixed) return this.alertOpen(event, alertMessage);
    }
    this.props.toggleCodeOpen();
  };

  showModal = (value) => {
    this.props.showModal(value);
    this.setState({ menuOpen: null, showToolTip: null });
}

  toggleSendOpen = event => {
    const { selectedTransactions } = this.props;
    this.props.toggleSendOpen(selectedTransactions);
  };

  alertClose = () => {
    this.setState({ alertOpen: null });
  };

  alertOpen = (event, alertMessage) => {
    this.setState({ alertOpen: event.currentTarget, alertMessage });
  };


  render() {
    const { isRah, codeOpen, postToRAH, transactions, rahSyncing, rahSyncProgress, retryQueueRAH, queueState, matches, selectedTransactions, filterBy } = this.props;
    const { filterOpen, alertOpen } = this.state;

    const CloseTooltip = withStyles({ tooltip: { marginBottom: -1, fontSize: 13 } })(Tooltip);

    const isSelected = selectedTransactions.length > 0;
    const isMatchable = Boolean(isSelected && selectedTransactions.every(row => checkIsMatchable(row, matches)));
    const isRuleable = Boolean(isSelected && selectedTransactions.every(row => isUnappliedRule(row)));
    const isCodeOpen = isSelected && codeOpen;
    const filterOptions = isRah ? filterByOptions : filterByOptions.slice(0, -2); // remove 'Matched' and 'Unapplied Rules' options for non RAH accounts

    const enableRules = localStorage.getItem("enablerules");

    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexDirection: 'row-reverse', height: 55 }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {isSelected && <div style={{ paddingRight: 20, boxShadow: '1px 0 0 rgba(100,121,143,0.122)', height: 30 }}>
            <div style={{ fontStyle: 'italic', fontSize: 12, color: 'grey', marginTop: 6 }}>
              Selected {selectedTransactions.length} of {transactions}
            </div>
          </div>}

          {queueState.retryError && <div style={{ paddingRight: 20, boxShadow: '1px 0 0 rgba(100,121,143,0.122)', height: 30 }}>
            <div style={{ fontStyle: 'italic', fontSize: 12, color: 'red', marginTop: 6 }}>
              {queueState.retryError} - Click the retry icon to the right to try sync again
                    </div>
          </div>}

          {isRah && 
            <React.Fragment>
            {this.props.lastSync && this.props.lastSync.all &&
              <span style={{ fontSize: 12, marginTop: 5, padding: 10 }}> Last Synced {moment(this.props.lastSync.all).format('HH:mm DD/MM')}</span>
            }
            {rahSyncing ?
              <Badge badgeContent={isNaN(rahSyncProgress) ? '' : `${rahSyncProgress}%`} style={{ marginRight: '15px' }} >
                <CircularProgress size={22} style={{ marginRight: '15px', marginBottpm: '1px' }} />
              </Badge>
              : <CloseTooltip title="Sync" placement="top">
                <IconButton aria-label="sync" onClick={postToRAH}>
                  <i className="fas fa-sm fa-exchange-alt"></i>
                </IconButton>
              </CloseTooltip>}

            {Boolean(queueState.retryableCount) && <CloseTooltip title="Retry failed transactions" placement="top">
              <IconButton aria-label="sync" onClick={retryQueueRAH}>
                <i className="fas fa-retweet" style={{ color: '#EC7063' }}></i>
              </IconButton>
            </CloseTooltip>}

          </React.Fragment>}
        </div>

        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ height: 30, boxShadow: 'inset -1px 0 0 rgba(100,121,143,0.122)' }}>
            <IconButton style={{ margin: '-9px 5px 0px 8px' }} aria-label="filter" onClick={this.handleFilterOpen}>
              <CloseTooltip title="Filter" placement="top">
                <FilterListIcon style={{ color: filterBy === 'All' ? '#888' : '#19aad2' }} />
              </CloseTooltip>
            </IconButton>
            <Menu
              id="select-menu"
              getContentAnchorEl={null}
              anchorEl={filterOpen}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
              }}
              keepMounted
              open={Boolean(filterOpen)}
              onClose={this.selectClose} >
              {filterOptions.map((option, idx) => (
                <MenuItem key={idx} selected={this.props.filterBy === option} onClick={() => this.onFilterchanged(option)}>{option}</MenuItem>
              ))}
            </Menu>
          </div>
          <div>
            <div style={{ display: 'flex', fontSize: 'smaller' }}>
              {isSelected &&
                <IconButton aria-label="code" onClick={this.toggleCodeOpen}>
                  <CloseTooltip title="Code" placement="top">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <CopyrightIcon />
                      <span style={{ fontSize: 11, color: 'grey', marginTop: 2 }}>Batch Coding</span>
                    </div>
                  </CloseTooltip>
                </IconButton>}
              { (enableRules && isSelected) &&
              <IconButton aria-label="send" onClick={this.toggleSendOpen}>
                  <CloseTooltip title="Send" placement="top">
                     <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <MailOutlineIcon />
                      <span style={{ fontSize: 11, color: 'grey', marginTop: 2 }}>Send</span>
                    </div>
                  </CloseTooltip>
                </IconButton>}
              {isCodeOpen &&
                <TransactionCodeForm
                  account={this.props.account}
                  onSubmit={this.handleCoding}
                  transactionCodes={this.props.transactionCodes}
                  classification={this.props.classification}
                  isR1={this.props.isR1}
                  isRah={isRah}
                  displayAccount={this.props.displayAccount}
                  chart={this.props.chart}
                  contacts={this.props.contacts}
                  selectedTransactions={selectedTransactions}
                  taxTracking={this.props.taxTracking}
                />
              }
              {isMatchable && !isCodeOpen &&
                <IconButton aria-label="match" onClick={this.handleSelectedMatch}>
                  <CloseTooltip title="Apply Match" placement="top">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <WhatshotRoundedIcon />
                      <span style={{ fontSize: 11, color: 'grey', marginTop: 2 }}>Apply Matches</span>
                    </div>
                  </CloseTooltip>
                </IconButton>}
              {isRuleable && !isCodeOpen &&
                <IconButton aria-label="rule" onClick={this.handleSelectedRule}>
                  <CloseTooltip title="Apply Rule" placement="top">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <i className="fas fa-sm fa-registered"></i>
                      <span style={{ fontSize: 11, color: 'grey', marginTop: 2 }}>Apply Rules</span>
                    </div>
                  </CloseTooltip>
                </IconButton>}
              <Popover
                id="code-menu"
                open={Boolean(alertOpen)}
                anchorEl={alertOpen}
                onClose={this.alertClose}
                anchorOrigin={{
                  vertical: 'center',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'center',
                  horizontal: 'left',
                }}>
                <div className={classes.statusLabel} >
                  <i className="fas fa-exclamation-circle" style={{ color: 'darkorange' }}></i> {this.state.alertMessage}
                </div>
              </Popover>
            </div>
          </div>
        </div>
      </div >
    )
  }
}

function mapStateToProps(state) {
  return {
    selectedTransactions: state.transactions.selectedTransactions,
  };
}

export default connect(mapStateToProps, actions)(TransactionListMenu);


// WEBPACK FOOTER //
// ./src/components/TransactionList/TransactionListMenu.js